import script from "./GridProspectoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridProspectoComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridProspectoComponent.vue?vue&type=style&index=0&id=fc803c9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc803c9e"]])

export default __exports__